// @flow
// OpenAI Ads CAPI attribution capture.
// Keep __oppref raw and opaque: do not decode, parse, normalize, or log it.

const readRawCookie = (name: string): string => {
  if (typeof document === 'undefined' || !document.cookie) return '';
  const prefix = `${name}=`;
  const hit = document.cookie.split(';').find(part => {
    const index = part.indexOf(prefix);
    return index >= 0 && part.slice(0, index).trim() === '';
  });
  if (!hit) return '';
  return hit.slice(hit.indexOf(prefix) + prefix.length);
};

const getCurrentSourceUrl = (): string => {
  if (typeof window === 'undefined' || !window.location) return '';

  try {
    const url = new URL(window.location.href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
    return `${url.origin}${url.pathname}`;
  } catch (e) {
    return '';
  }
};

export const getOpenAiAdsAttribution = (): {
  oppref: string,
  sourceUrl: string,
  capturedAt: string,
} => {
  try {
    return {
      oppref: readRawCookie('__oppref'),
      sourceUrl: getCurrentSourceUrl(),
      capturedAt: new Date().toISOString(),
    };
  } catch (e) {
    return {
      oppref: '',
      sourceUrl: '',
      capturedAt: new Date().toISOString(),
    };
  }
};

export default getOpenAiAdsAttribution;



// WEBPACK FOOTER //
// ./src/lib/tracking/openaiAdsAttribution.js